module.exports = __webpack_public_path__ + "assets/img/555.0a70b406.jpg";